export default __webpack_public_path__ + "static/media/flag-ma.73d113d3.svg";